export const assetTypes = ["PILE", "CAP_BEAM", "BOLLARD"] as const;
export type AssetType = (typeof assetTypes)[number];

export const loadGovernedAssetTypes = ["PILE", "CAP_BEAM"] as const;

export function labelFromAssetType(assetType: AssetType): string {
  return assetTypeToLabelMap[assetType];
}

export function assetCollectionFromAssetType(
  assetType: AssetType,
): AssetCollection {
  return assetTypeToAssetCollectionMap[assetType];
}

export function isValidAssetCollection(
  collection: string,
): collection is AssetCollection {
  return collection in assetCollectionToAssetTypeMap;
}

export function assetTypeFromAssetCollection(
  collection: AssetCollection,
): AssetType {
  return assetCollectionToAssetTypeMap[collection];
}

export type AssetCollection = "piles" | "cap_beams" | "bollards";

const assetTypeToLabelMap: Record<AssetType, string> = {
  PILE: "Pile",
  CAP_BEAM: "Cap beam",
  BOLLARD: "Bollard",
};

const assetCollectionToAssetTypeMap: Record<AssetCollection, AssetType> = {
  piles: "PILE",
  cap_beams: "CAP_BEAM",
  bollards: "BOLLARD",
};

const assetTypeToAssetCollectionMap: Record<AssetType, AssetCollection> = {
  PILE: "piles",
  CAP_BEAM: "cap_beams",
  BOLLARD: "bollards",
};
